let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fbDZw")).then(() => parcelRequire('2J7a0'));